// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"75cc7f65","464":"f97c12a9","928":"5d0e2427"}[chunkId] + ".chunk.js";
};